// extracted by mini-css-extract-plugin
module.exports = {"root":"SidebarNav_root__1XmlN","sidebar":"SidebarNav_sidebar__3oruM","children":"SidebarNav_children__1d3ek"};